import { STRINGS } from 'src/features/auth/auth.strings';
import type { LoginProviders } from './types';

export const LOGIN_PROVIDER: Record<LoginProviders, LoginProviders> = {
  Apple: 'Apple',
  Facebook: 'Facebook',
  Google: 'Google',
  LinkedIn: 'LinkedIn',
};

export const GOOGLE_OAUTH_CLIENT_ID =
  process.env.NEXT_PUBLIC_GOOGLE_OAUTH_CLIENT_ID || '';

export const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID || '';

export const REDIRECT_URI = process.env.NEXT_PUBLIC_HOST || '';

export const TOKEN_EMAIL_MISMATCH = 'TOKEN_EMAIL_MISMATCH';

export const DEFAULT_REGION_PHONE_NUMBER = '(833) 313-2564';

export const EMAIL_TAKEN_API_CODE = 'EMAIL_TAKEN';
export const SET_PASSWORD_MODULES_TO_SHOW_FOOTER = ['wealth'];

export const PROVIDER_ICON = {
  google: '/icons/google.svg',
  apple: '/icons/apple_logo.svg',
  facebook: '/icons/facebook.svg',
};

export const PROVIDER_COPY = {
  google: STRINGS.connectedGoogle,
  apple: STRINGS.connectedApple,
  facebook: STRINGS.connectedFacebook,
};
